import { render } from "./AppWrapper.vue?vue&type=template&id=a6041fa8"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01.Works\\BoonRock\\114.X1Studio\\001.PMS\\31.Dev\\99_source\\crm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__